import { Navigate } from 'react-router-dom';

import { useTypedParams } from '@sorare/routing';

import { ANY_SPORT_PLAY_EVENTTYPE_FIXTURE_LINEUPS } from '@sorare/core/src/constants/__generated__/routes';
import { useSportContext } from '@sorare/core/src/contexts/sport';

import type { PageParams } from './__generated__/routeParams';

const PlayProFixturePage = () => {
  const { generateSportContextPath } = useSportContext();
  const { fixture, eventType } = useTypedParams<PageParams>();

  return (
    <Navigate
      to={generateSportContextPath(ANY_SPORT_PLAY_EVENTTYPE_FIXTURE_LINEUPS, {
        params: {
          fixture,
          eventType,
        },
      })}
      replace
    />
  );
};

export default PlayProFixturePage;
